var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('money',{attrs:{"id":_vm.question.id,"name":_vm.question.id,"fractions":true},on:{"blur":function($event){return _vm.update()}},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }